import React from "react";
import { Input } from "@/components/ui/input";
import { formatIndianNumber, parseIndianNumber } from "@/lib/format";

/**
 * Reusable numeric text input with:
 *   - Indian-style comma formatting as you type (1,00,000)
 *   - no mouse-wheel / trackpad increment
 *   - no negative numbers
 *   - no browser spinner arrows
 * value = number | null. onChange = (number | null) => void.
 */
export default function IndianNumberInput({
  value, onChange, placeholder = "0", testId, disabled = false, prefix = "\u20B9", ...rest
}) {
  const display = value === null || value === undefined || value === "" ? "" : formatIndianNumber(value);

  const handleChange = (e) => {
    const raw = parseIndianNumber(e.target.value);
    if (raw === "") { onChange(null); return; }
    onChange(Number(raw));
  };

  const blockWheel = (e) => e.target.blur();
  const blockKey = (e) => {
    // block e/E/-/+ if the browser thinks it's a number field
    if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
  };

  return (
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm pointer-events-none">
          {prefix}
        </span>
      )}
      <Input
        type="text"
        inputMode="numeric"
        pattern="[0-9,]*"
        value={display}
        onChange={handleChange}
        onWheel={blockWheel}
        onKeyDown={blockKey}
        placeholder={placeholder}
        disabled={disabled}
        data-testid={testId}
        className={prefix ? "pl-8" : ""}
        {...rest}
      />
    </div>
  );
}
